import React from "react";
import DatamapsIndia from "react-datamaps-india";

const IndiaMap = ({ selectedState, PanIndia}) => {
  // Get a list of all states (keys must match DatamapsIndia state names)
  const allStates = [
    "Andaman & Nicobar Island", "Andhra Pradesh", "Arunachal Pradesh", "Assam",
    "Bihar", "Chandigarh", "Chhattisgarh", "Dadra & Nagar Haveli", "Daman & Diu",
    "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu & Kashmir",
    "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh",
    "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha",
    "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
    "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
  ];

  const statesArray = PanIndia
    ? allStates
    : selectedState
    ? selectedState.split(",").map((state) => state.trim())
    : [];

  // Generate regionData for the shaded states
  const regionData = statesArray.reduce((acc, state) => {
    acc[state] = { value: 1000 };
    return acc;
  }, {});

  const handleHover = (state) => {
    if (!statesArray.includes(state)) {
      return {
        hoverColor: "transparent",
        hoverBorderColor: "transparent",
      };
    }
    return {
      hoverColor: "#fec74e",
      hoverBorderColor: "#8D8D8D",
    };
  };

  return (
    <div style={{ height: "400px", width: "500px" }}>
      <DatamapsIndia
        regionData={regionData}
        hoverComponent={({ value }) => {
          return !statesArray.includes(value.name) ? (
            <div className="text-gray-400 min-w-0 leading-3 text-sm">{value.name}</div>
          ) : (
            <div className="text-[#004878] bg-[#fec74e] px-2 leading-6">{value.name}</div>
          );
        }}
        mapLayout={{
          startColor: PanIndia ? "#fec74e" : '#fec74e',  // Pure yellow
          endColor: PanIndia ? "#fec74e" : '#fec74e',    // Orange (yellow-orange gradient)
          borderColor: "#004878",
          hoverBorderColor: "#004878",
          hoverColor: "#f5f5f5",
          color: "red",
          height: 400,
          width: 500,
        }}
        onHover={handleHover}
      />
    </div>
  );
};

export default IndiaMap;
